<template>
  <div
    class="ui-dropdown"
    :class="classList"
    :style="styleList"
  >
    <div class="ui-dropdown__content" :style="contentStyleList">
      <slot />
    </div>
  </div>
</template>

<script>
import { POSITIONS } from '../libs/helpConsts'
import { getDropdownPosition } from '../libs/helpTools'

export default {
  props: {
    maxWidth: {
      type: Number,
      default: 350
    },
    minWidth: {
      type: Number,
      default: 120
    },
    maxHeight: {
      type: Number,
      default: 270
    },
    container: HTMLElement
  },
  data () {
    return {
      dropdownPosition: {
        x: POSITIONS.RIGHT,
        y: POSITIONS.BOTTOM,
        maxWidth: null,
        minWidth: null
      }
    }
  },
  computed: {
    styleList () {
      return {
        maxWidth: `${this.dropdownPosition.maxWidth}px`,
        minWidth: `${this.dropdownPosition.minWidth}px`
      }
    },
    contentStyleList () {
      return {
        maxHeight: `${this.maxHeight}px`
      }
    },
    classList () {
      return [
        `_position_${this.dropdownPosition.x}`,
        `_position_${this.dropdownPosition.y}`
      ]
    },
    windowWidth () {
      return this.$root.windowWidth
    }
  },
  watch: {
    windowWidth: {
      handler () {
        this.updateDropdownPosition()
      },
      immediate: true
    }
  },
  methods: {
    updateDropdownPosition () {
      this.dropdownPosition = getDropdownPosition(this.container, this.maxHeight, this.maxWidth, this.minWidth)
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-dropdown {
  $parent: &;
  position: absolute;
  z-index: 2;
  min-width: 120px;
  width: max-content;

  &._position {
    &_top {
      bottom: 100%;

      #{$parent}__content {
        margin-bottom: 1px;
        box-shadow: 0 -12px 16px rgba($gray-3, 0.2);
      }
    }

    &_bottom {
      top: 100%;

      #{$parent}__content {
        margin-top: 1px;
        box-shadow: 0 12px 16px rgba($gray-3, 0.2);
      }
    }

    &_center {
      right: 50%;
      transform: translateX(50%);
    }

    &_left {
      right: 0;
    }
  }

  &__content {
    @include pretty-scrollbar-s;
    position: relative;
    display: flex;
    flex-direction: column;
    border: 1px solid $gray-6;
    border-radius: $border-radius-01;
    background: #fff;
    overflow-y: auto;
    z-index: 1;
  }

  ::v-deep(.ui-select-option-item + .ui-select-option-item) {
    border-top: 1px solid $gray-6;
  }
}
</style>
